const state = {
  movies: [],
  cinemas: [],
  selectedCinema: undefined,
  selectedMovies: [],
  ticket: {},
};

export default state;
